import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { createQueryOptions } from '../../query';
import { useStoreApi } from '../api';
import { PurchasesSearch } from './search.types';
import { ListCausesPurchasedResponse, ListPurchasesResponse } from './types';

const useListUserPurchases = ({ queryOptions }: { queryOptions?: PurchasesSearch }) => {
  const StoreApi = useStoreApi();

  // this instance of createQueryOptions is to add specificity to the queryKey
  const { queryObject, queryPagination } = createQueryOptions<PurchasesSearch>({
    search: queryOptions,
  });

  const getUserPurchases = async ({ pageParam }: { pageParam: { limit: number; offset: number } }) => {
    // this instance of createQueryOptions is to create the query string based on updating pageParams
    const { queryString } = createQueryOptions<PurchasesSearch>({
      search: queryOptions,
      pagination: {
        limit: pageParam.limit,
        offset: pageParam.offset,
      },
    });

    const { data } = await StoreApi.get<ListPurchasesResponse>(
      `/consumer/cart_items?${queryString}`
    );
    return data;
  };

  return useInfiniteQuery({
    queryFn: getUserPurchases,
    queryKey: ['store', 'cart_items', queryObject, queryPagination],
    initialPageParam: { limit: 10, offset: 0 },
    getNextPageParam: (lastPageData) => {
      const { meta } = lastPageData;
      const { has_more, limit, offset } = meta;
      if (!has_more) {
        return undefined;
      }
      return { limit, offset: offset + limit };
    },
  });
};

const useListCausesPurchased = () => {
  const StoreApi = useStoreApi();

  const getUserPurchases = async () => {
    const { data } = await StoreApi.get<ListCausesPurchasedResponse>('/consumer/causes');
    return data;
  };

  return useQuery({
    queryFn: getUserPurchases,
    queryKey: ['store', 'cart_items', 'causes'],
  });
};

export { useListCausesPurchased, useListUserPurchases };
